import React, {Component} from "react";
import $ from 'jquery';
import {getLineWidget, getPopulars} from "../redux/actions/line";
import {connect} from "react-redux";
import Xhr from "../helpers/Xhr";
import {Redirect} from "react-router-dom";
import {filterData} from "../redux/actions/event-filter";

class EventFilter extends Component {
	defaultText = 'События за всё время';

	text = {
		0 : this.defaultText,
		1 : 'за 1 час',
		2 : 'за 3 часа',
		3 : 'за 6 часов',
		4 : 'за 12 часов',
		5 : 'за 24 часа',
		6 : 'за 30 минут',
	};

	state = {
		leaguesLink  : ''
	};

	constructor(props) {
		super(props);
	}

	componentWillReceiveProps(nextProps) {
		if (nextProps.filter.linePeriod !== this.props.filter.linePeriod) {
			this.loadData(nextProps);
			this.eventFilterToggle();
		}
	}

	eventFilterToggle(event = null) {
		if (event !== null) {
			event.preventDefault();
		}

		$(this.refs['event-filter-toggle']).toggle();
		$(this.refs['event-filter-open']).toggleClass('rotate');
	}

	changeFilter(e) {
		const active = parseInt(e.target.value);
		this.props.onFilterData('linePeriod', active);
	}

	loadData(props = null) {
		let data = props === null ? this.props : props;
		this.props.onGetLineWidget(data.filter.linePeriod);
		this.props.onGetPopulars(data.filter.linePeriod);
	}

	showFiltered(event) {
		event.preventDefault();
		this.loadData();
		this.eventFilterToggle(event);
	}

	go(event) {
		event.preventDefault();

		Xhr.getLeague(this.props.line.lineWidget.sports.map((sport) => sport.id).join('-'), this.props.filter.linePeriod).then((resp) => {
			this.setState({
				leaguesLink : resp ? `/line-leagues/${resp.data.leagues.map((item) => item.id).join('-')}` : ''
			});
		});
	}

	clear(event) {
		event.preventDefault();
		this.props.onFilterData('linePeriod', 0);
		this.loadData();
	}

	render() {
		if ( this.state.leaguesLink !== '' ) {
			return <Redirect to={this.state.leaguesLink}/>
		}

		return (
			<div>
				<div className="event-filter" onClick={this.eventFilterToggle.bind(this)}>
					<i className="event-filter__icon fa fa-calendar"></i>
					<span>{this.text[this.props.filter.linePeriod]}</span>
					{this.props.filter.linePeriod !== 0 &&
					<span className="event-filter__go" onClick={this.go.bind(this)}>
						<i className="fas fa-arrow-right"></i>
					</span>}
					<a className="event-filter__open" ref="event-filter-open" >
						<i className="fas fa-chevron-down"></i>
					</a>
				</div>
				<div className="event-filter__list" ref="event-filter-toggle">
					<form>
						<input type="radio" name="event-filter" value="0" id="all" checked={this.props.filter.linePeriod === 0}
						       onChange={this.changeFilter.bind(this)}/>
						<label htmlFor="all">все</label>

						<input type="radio" name="event-filter" value="6" id="for-30-minutes" checked={this.props.filter.linePeriod === 6}
						       onChange={this.changeFilter.bind(this)}/>
						<label htmlFor="for-30-minutes">за 30 минут</label>

						<input type="radio" name="event-filter" value="1" id="for-1-hour" checked={this.props.filter.linePeriod === 1}
						       onChange={this.changeFilter.bind(this)}/>
						<label htmlFor="for-1-hour">за 1 час</label>

						<input type="radio" name="event-filter" value="2" id="for-3-hours" checked={this.props.filter.linePeriod === 2}
						       onChange={this.changeFilter.bind(this)}/>
						<label htmlFor="for-3-hours">за 3 часа</label>

						<input type="radio" name="event-filter" value="3" id="for-6-hours" checked={this.props.filter.linePeriod === 3}
						       onChange={this.changeFilter.bind(this)}/>
						<label htmlFor="for-6-hours">за 6 часов</label>

						<input type="radio" name="event-filter" value="4" id="for-12-hours" checked={this.props.filter.linePeriod === 4}
						       onChange={this.changeFilter.bind(this)}/>
						<label htmlFor="for-12-hours">за 12 часов</label>

						<input type="radio" name="event-filter" value="5" id="for-24-hours" checked={this.props.filter.linePeriod === 5}
						       onChange={this.changeFilter.bind(this)}/>
						<label htmlFor="for-24-hours">за 24 часа</label>

						{/*<div className="event-filter__list-buttons buttons">*/}
							{/*/!*<button className="buttons__show" onClick={this.showFiltered.bind(this)}>Показать</button>*!/*/}
							{/*/!*<button className="buttons__clear" type="reset" onClick={this.clear.bind(this)}>Очистить</button>*!/*/}
						{/*</div>*/}
					</form>
				</div>
			</div>);
	}
}

export default connect(
	state => ({
		line   : state.line,
		filter : state.filter
	}),
	dispatch => ({
		onGetPopulars   : (period) => {
			dispatch(getPopulars(period));
		},
		onGetLineWidget : (period) => {
			dispatch(getLineWidget(period));
		},
		onFilterData    : (type, data) => {
			dispatch(filterData(type, data));
		}
	})
)(EventFilter);


// WEBPACK FOOTER //
// ./src/app/components/EventFilter.js